// src/hooks/useCurrentPlan.ts
import { API_URL } from '@/config/api';
import { useOrganizationStore } from '@/store/useOrganizationStore'; // + Import organization store
import { useUserStore } from '@/store/useUserStore';
import { UserPlan } from '@/types/plan'; // Import the new global type
import { useQuery } from '@tanstack/react-query';

export const useCurrentPlan = () => {
  const { session } = useUserStore();
  const { selectedOrganizationId } = useOrganizationStore(); // Use selectedOrganizationId

  return useQuery<UserPlan | undefined>({
    queryKey: [
      'currentOrganizationPlan',
      selectedOrganizationId, // Use selectedOrganizationId
      session?.access_token,
    ],
    queryFn: async (): Promise<UserPlan | undefined> => {
      if (!selectedOrganizationId || !session?.access_token) return undefined; // Check selectedOrganizationId

      const response = await fetch(
        `${API_URL}/api/v1/organizations/${selectedOrganizationId}/plan`, // Use selectedOrganizationId
        {
          headers: { Authorization: `Bearer ${session?.access_token}` },
        }
      );

      if (!response.ok) {
        console.error(
          `Failed to fetch current plan for organization ${selectedOrganizationId}: ${response.status}` // Log selectedOrganizationId
        );
        if (response.status === 404) {
          console.warn(
            `No active plan found for organization ${selectedOrganizationId} (404).` // Log selectedOrganizationId
          );
          return undefined;
        }
        return undefined;
      }
      const data = await response.json();
      console.log('Current plan API response:', data);
      console.log('next_renovation_date field:', data.next_renovation_date);
      return data;
    },
    enabled: !!selectedOrganizationId && !!session?.access_token, // Use selectedOrganizationId
    // Optional: Add staleTime and cacheTime as needed for your application's data freshness requirements
    // staleTime: 5 * 60 * 1000, // 5 minutes
    // cacheTime: 10 * 60 * 1000, // 10 minutes
  });
};
